/**
 * URLs canónicas de las capas geoespaciales.
 *
 * Modo único: GeoJSON estático servido por la SPA (`/maps/<file>.geojson`).
 * Cada SPA copia data/final/*.geojson a su public/maps/ via
 * scripts/sync-maps.mjs.
 *
 * Prefijamos `import.meta.env.BASE_URL` para despliegues bajo subruta (Vite).
 */

export interface DataSources {
  aoi: string;
  /** AOI alternativo (San Pedro unificado), ver `aoi_san_pedro_unificado.geojson`. */
  aoi_san_pedro: string;
  aoi_union: string;
  municipios: string;
  nucleos: string;
  parcelas: string;
  uso_comun: string;
  zonas_parceladas: string;
  asentamientos: string;
  macroalineamiento: string;
}

/** Resuelve ruta bajo el mismo origen que la SPA (subruta incluida). */
function mapAsset(path: string): string {
  const raw = import.meta.env?.BASE_URL ?? '/';
  if (raw === '/') return path.startsWith('/') ? path : `/${path}`;
  const base = raw.endsWith('/') ? raw.slice(0, -1) : raw;
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${base}${p}`;
}

const PATHS: DataSources = {
  aoi:               mapAsset('/maps/aoi.geojson'),
  aoi_san_pedro:     mapAsset('/maps/aoi_san_pedro_unificado.geojson'),
  aoi_union:         mapAsset('/maps/aoi_union.geojson'),
  municipios:        mapAsset('/maps/municipios.geojson'),
  nucleos:           mapAsset('/maps/nucleos_agrarios.geojson'),
  parcelas:          mapAsset('/maps/parcelas_unificado.geojson'),
  uso_comun:         mapAsset('/maps/uso_comun.geojson'),
  zonas_parceladas:  mapAsset('/maps/zonas_parceladas.geojson'),
  asentamientos:     mapAsset('/maps/asentamientos.geojson'),
  macroalineamiento: mapAsset('/maps/macroalineamiento.geojson'),
};

/** Resuelve URLs de fuentes. Hoy retorna siempre los GeoJSON locales. */
export function resolveDataSources(): DataSources {
  return PATHS;
}

/** Default legacy: alias de resolveDataSources(). */
export const DATA_SOURCES_DEFAULT: DataSources = PATHS;

export const VIEWPORT_DEFAULT = {
  centro: [-100.389, 20.399] as [number, number],
  zoom: 13,
  pitch: 0,
  bearing: 0,
};
